import { Injectable } from '@angular/core';
import { GlobalAction, GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';

@Injectable({
  providedIn: 'root',
})
export class GlobalEventDispatcherService {
  globalEventDispatcherRef: GlobalEventDispatcher = (window as unknown as Record<string, unknown>)['globalEventDispatcher'] as GlobalEventDispatcher;

  dispatch(action: GlobalAction<unknown> | string): void {
    this.globalEventDispatcherRef.dispatch(action as GlobalAction<unknown>);
  }
}
